const StudyTaskTypeEnum = {
    MISSING_IMAGE: 1,
    RE_ASSESSMENT: 2,
    REMOVE_REPORT_CONFIRMATION: 3,
}

// Görev tipinin i18n anahtarı; bilinmeyen tipler için genel 'Task' etiketi.
export const studyTaskTypeKey = (taskType) => ({
    [StudyTaskTypeEnum.MISSING_IMAGE]: 'MISSING_IMAGE',
    [StudyTaskTypeEnum.RE_ASSESSMENT]: 'RE_ASSESSMENT',
    [StudyTaskTypeEnum.REMOVE_REPORT_CONFIRMATION]: 'REMOVE_REPORT_CONFIRMATION',
}[taskType] || 'Task')

// Açık görev listesi için tek satırlık etiket: yeniden değerlendirme varsa o öne çıkar.
export const studyTaskListKey = (tasks) => (
    tasks?.some(x => x.taskType === StudyTaskTypeEnum.RE_ASSESSMENT)
        ? 'Re-Assessment'
        : studyTaskTypeKey(tasks?.[0]?.taskType)
)

export default StudyTaskTypeEnum
